import React from 'react';
import { UserCheck, HeartHandshake } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-19">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-20">
        {/* Patient Benefits */}
        <div data-id="element-21">
          <div className="flex items-center gap-3 mb-6" data-id="element-22">
            <div className="p-3 bg-green-100 rounded-full text-green-600" data-id="element-23">
              <HeartHandshake className="w-6 h-6" data-id="element-24" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-25">
              ¿Qué logran tus pacientes?
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-26">
            {['Mayor claridad sobre su proceso terapéutico', 'Mejor adherencia al tratamiento', 'Sesiones más estructuradas', 'Continuidad real en el trabajo clínico', 'Mayor sensación de seguridad'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-green-50/50 p-3 rounded-lg" data-id="element-27">
                <div className="w-5 h-5 rounded-full bg-green-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-28">
                  <span className="text-green-700 text-xs font-bold" data-id="element-29">✓</span>
                </div>
                <span className="text-gray-700 font-medium" data-id="element-30">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Psychologist Benefits */}
        <div data-id="element-31">
          <div className="flex items-center gap-3 mb-6" data-id="element-32">
            <div className="p-3 bg-purple-100 rounded-full text-purple-600" data-id="element-33">
              <UserCheck className="w-6 h-6" data-id="element-34" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-35">
              ¿Qué logras tú como psicóloga?
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-36">
            {['Ahorrar horas de planificación cada semana', 'Dejar de improvisar', 'Sentirte más segura en cada sesión', 'Contar con un sistema claro de trabajo', 'Reducir la carga mental', 'Volver a disfrutar tu práctica profesional'].map((item, i) => <li key={i} className="flex items-start gap-3 bg-purple-50/50 p-3 rounded-lg" data-id="element-37">
                <div className="w-5 h-5 rounded-full bg-purple-200 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-38">
                  <span className="text-purple-700 text-xs font-bold" data-id="element-39">✓</span>
                </div>
                <span className="text-gray-700 font-medium" data-id="element-40">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}